import { selectEditMode, selectWorkExperience } from '../../../../store/signUp/selectors';
import WorkExperienceForm from '../../components/WorkExperienceForm';
import { useDispatch, useSelector } from '../../../../store/store';
import MotionWrapper from '../../../../containers/MotionWrapper';
import RadioButton from '../../../../components/RadioButton';
import Button from '../../../../components/Button';
import styles from './style.module.scss';
import { useState } from 'react';
import {
    setSignUpStep,
    setWorkExperience,
    resetWorkExperience,
} from '../../../../store/signUp/slice';

function WorkExperience() {
    const dispatch = useDispatch();
    const editMode = useSelector(selectEditMode);
    const [noExperience, setNoExperience] = useState(false);
    const workExperiences = useSelector(selectWorkExperience);

    const disableNextStep = workExperiences.some(({
        to,
        from,
        company,
        location,
        jobTitle,
        roleDescription,
        currentlyworkHere }) => {

        return !company ||
            !from ||
            !location ||
            !jobTitle ||
            !roleDescription ||
            !(currentlyworkHere || to !== "") ||
            new Date(from) > new Date(to);
    });

    const haveNoExperience = (val: boolean) => {
        setNoExperience(val);
        dispatch(resetWorkExperience());
    };

    const next = () => {
        dispatch(setSignUpStep(editMode ? 'reviewInfo' : 'education'));
    };

    return (
        <MotionWrapper className={styles.wrapper}>
            <RadioButton
                text="I don't have work experience."
                checked={noExperience}
                setChecked={haveNoExperience}
            />
            {!noExperience && (<>
                {workExperiences.map(item => <WorkExperienceForm data={item} />)}
                <Button
                    type='Outline-Primary'
                    text={workExperiences.length === 0 ? '+ Add job' : '+ Add another'}
                    disabled={workExperiences.length === 5}
                    onClick={() => dispatch(setWorkExperience())}
                    className={styles.add}
                />
            </>)}
            <div className={styles.actions}>
                <Button
                    size='sm'
                    text='Back'
                    type='Outline-Dark'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setSignUpStep('uploadPersonalID'))}
                />
                <Button
                    size='sm'
                    type='Primary'
                    onClick={next}
                    className={styles.actions_btn}
                    text={editMode ? 'Save' : 'Continue'}
                    disabled={(workExperiences.length === 0 ? !noExperience : disableNextStep)}
                />
            </div>
        </MotionWrapper>
    );
};

export default WorkExperience;
